var map = {
	"./Expand-all.svg": 16219,
	"./Group.svg": 63008,
	"./LogOut.svg": 89026,
	"./Popup-question.svg": 58649,
	"./Radio.svg": 26515,
	"./Reservation.svg": 98650,
	"./accident-button.svg": 92760,
	"./accordian-icon.svg": 66617,
	"./add-icon.svg": 10716,
	"./alert-circle.svg": 10434,
	"./alert-triangle-icon.svg": 18393,
	"./ap-ar-dark.svg": 57937,
	"./ap-ar.svg": 63559,
	"./approval -popup.svg": 8595,
	"./approve-icon.svg": 55956,
	"./archive-icon.svg": 76588,
	"./arrow-curve-left-up.svg": 90015,
	"./arrow-down-light.svg": 83478,
	"./arrow-down.svg": 85011,
	"./arrow-icon.svg": 76508,
	"./arrow-refresh-icon.svg": 29009,
	"./arrow-right.svg": 18264,
	"./arrows-up.svg": 78458,
	"./bank.svg": 90119,
	"./bell.svg": 80204,
	"./branch-icon.svg": 20037,
	"./bread_crumb.svg": 66056,
	"./bread_crumb_double.svg": 97441,
	"./calendar-01.svg": 22538,
	"./calendar-03.svg": 91810,
	"./calendar-icon.svg": 60034,
	"./calendar.svg": 64674,
	"./car-icon.svg": 47877,
	"./change-status.svg": 87373,
	"./charter-icon.svg": 58356,
	"./check-black-icon.svg": 65102,
	"./check-broken.svg": 26743,
	"./check-icon.svg": 8798,
	"./chevron-down-blue.svg": 50849,
	"./chevron-down.svg": 43886,
	"./chevron.svg": 58136,
	"./client-dark.svg": 51544,
	"./client-edit.svg": 75488,
	"./client-info-icon.svg": 76157,
	"./client.svg": 17928,
	"./clock-1-icon.svg": 2821,
	"./clock-2-icon.svg": 64998,
	"./clock-icon.svg": 40011,
	"./clock.svg": 23826,
	"./close-icon.svg": 11570,
	"./closed-popup.svg": 47274,
	"./column-vertical.svg": 90398,
	"./company-detail.svg": 19631,
	"./company-details.svg": 4576,
	"./company-profile-dark.svg": 86802,
	"./company-profile.svg": 16997,
	"./confirm-with-note-icon.svg": 88904,
	"./contract-icon.svg": 28499,
	"./cross-icon-light.svg": 54772,
	"./cross-icon.svg": 20575,
	"./cycle-icon.svg": 38668,
	"./dashboard-dark.svg": 13896,
	"./dashboard.svg": 60118,
	"./delete-category.svg": 43298,
	"./download-02.svg": 57494,
	"./download-icon.svg": 69512,
	"./driver-edit.svg": 14154,
	"./driver-info-icon.svg": 5741,
	"./driver-picture-dummy-1.svg": 34340,
	"./driver-picture-dummy.svg": 64905,
	"./driver-remove-x.svg": 35294,
	"./driver-vehicle.svg": 47789,
	"./dry-clean-button.svg": 26614,
	"./edit-button.svg": 74537,
	"./edit-panicle.svg": 87790,
	"./edit-pen-custom.svg": 10952,
	"./edit-pen.svg": 96448,
	"./escalation.svg": 16515,
	"./excel-icon.svg": 54939,
	"./exclamation-mark.svg": 19866,
	"./export-icon.svg": 90737,
	"./file-1-icon.svg": 59913,
	"./file-attach.svg": 39627,
	"./file-icon.svg": 9462,
	"./finance-icon-dark.svg": 63073,
	"./finance-icon.svg": 79608,
	"./form-builder.svg": 52905,
	"./funnel-simple.svg": 1107,
	"./grid-icon.svg": 69339,
	"./image-icon.svg": 68406,
	"./image-placeholder.svg": 67391,
	"./import.svg": 47013,
	"./information-circle-blue.svg": 39169,
	"./insurance-button.svg": 6654,
	"./license-renewal-button.svg": 82463,
	"./list-icon.svg": 44084,
	"./location-icon.svg": 32991,
	"./maintenance-Button.svg": 45510,
	"./maintenance-vector.svg": 55092,
	"./management-system.svg": 96517,
	"./map.svg": 74156,
	"./message-square.svg": 58340,
	"./messaging-center-icon-light.svg": 50764,
	"./messaging-center-icon.svg": 32295,
	"./minus-circle-contained.svg": 61282,
	"./more-details.svg": 66532,
	"./move.svg": 4746,
	"./my-profile-dark.svg": 69812,
	"./my-profile.svg": 27027,
	"./new-list-icon.svg": 21061,
	"./operations.svg": 73481,
	"./paperclip-files.svg": 67219,
	"./pdf-icon.svg": 1404,
	"./person-vector.svg": 6836,
	"./phone-call.svg": 1230,
	"./pin-marker.svg": 24834,
	"./pincle-edit-light.svg": 51380,
	"./pincle-edit.svg": 65403,
	"./placeholder-add.svg": 4603,
	"./placeholder-location.svg": 2929,
	"./plus-danger.svg": 26165,
	"./plus-icon.svg": 90484,
	"./plus-secondary.svg": 91909,
	"./plus-white.svg": 59513,
	"./plus.svg": 74132,
	"./popup-cancel-icon.svg": 92119,
	"./popup-close.svg": 81446,
	"./popup-info-wide-icon.svg": 85158,
	"./popup-success-icon-new.svg": 42682,
	"./popup-success-icon.svg": 3138,
	"./popup-warning-icon.svg": 46461,
	"./printer.svg": 16152,
	"./recurrence-icon.svg": 6266,
	"./rejected-icon.svg": 14837,
	"./renewal-Button.svg": 86359,
	"./requests-icon-dark.svg": 39336,
	"./requests-icon.svg": 13703,
	"./returned-icon.svg": 56231,
	"./sales-icon-dark.svg": 44055,
	"./sales-icon-light.svg": 63626,
	"./search-bar-icon.svg": 22715,
	"./search-color-icon.svg": 80262,
	"./search-icon.svg": 10598,
	"./select-time.svg": 13577,
	"./setting-icon-dark.svg": 11199,
	"./setting-icon-light.svg": 49300,
	"./setting-icon.svg": 11664,
	"./shift-recurring-icon.svg": 32021,
	"./small-face-dark.svg": 98518,
	"./small-face.svg": 14484,
	"./small-truck.svg": 73713,
	"./sort-ascending.svg": 79571,
	"./sort-descending.svg": 22912,
	"./star.svg": 24281,
	"./start-marker.svg": 53751,
	"./step-shape.svg": 44678,
	"./switch-dark.svg": 33132,
	"./switch-outline.svg": 47395,
	"./system-management-dark.svg": 19468,
	"./ticket-button.svg": 12955,
	"./ticket-timer.svg": 75555,
	"./tickets-person.svg": 62855,
	"./tickets-timer-circle.svg": 51989,
	"./transfer-button.svg": 47583,
	"./trash-icon-red.svg": 71446,
	"./trash-icon.svg": 11537,
	"./trash-light-new.svg": 66554,
	"./trash-red-icon.svg": 51286,
	"./truck-icon.svg": 60290,
	"./trush-light.svg": 98610,
	"./trush.svg": 14486,
	"./upload-icon.svg": 73078,
	"./user-icon.svg": 26290,
	"./user-profile.svg": 51086,
	"./vehicle-picture-dummy.svg": 56281,
	"./warning-alert.svg": 31895,
	"./x-circle-contained.svg": 23407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20866;